import { useState, useEffect } from "react";
import salesInvoiceImg from "./assets/Image_SalesInvoice.png";
import creditNoteImg from "./assets/Image_CreditNote.png";
import AlertModal from './components/AlertModal';
import { kem } from "node-forge";


function ImagePopup({ src, alt, onClose }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/75 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative max-w-3xl w-full mx-4 bg-gray-900 rounded-2xl shadow-2xl p-4 border border-gray-600"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-white text-2xl font-bold leading-none transition-colors"
          aria-label="Close"
        >
          &times;
        </button>
        <p className="text-center text-cyan-300 font-semibold mb-3 text-lg">{alt}</p>
        <img
          src={src}
          alt={alt}
          className="w-full rounded-lg border border-gray-600 shadow-lg"
        />
      </div>
    </div>
  );
}

function AlertMe(){
  alert("Im testing");
}



const handleTestPost = async () => {
    //setLoading(true);
    try {
      const { managerApi } = await import('./serverjs/jofotaraFuncs.js');

      const value = {
        name: 'MyExtension2',
        source: 1,
        placement: 'sales-invoice-view',
        key: '72e778ab-bb54-4679-a0e7-b4e0e00a6751'
      };
      const business = "FASHION CHOISE(07.10.2025)"

      const payload = {
        value,business
      }
      console.log('🧪 Test POST payload:', payload);
      const response = await managerApi('POST', '/api4/extension', payload);
      console.log('🧪 Test POST response:', response);

      // const response = await managerApi('GET', '/api4/customers',null);
      // console.log('🧪 Test Businesses response:', response?.body);
      
    } catch (error) {
      console.error('Test POST error:', error);
     
    } finally {
      //setLoading(false);
    }
  };


function AppHome() {
  const [popup, setPopup] = useState(null); // null | 'sales' | 'credit'

  // useEffect(() => {
  //     alert('I am Loading');
  // },[]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 py-12 px-4 sm:px-6 lg:px-8">

      {/* Image Popups */}
      {popup === "sales" && (
        <ImagePopup
          src={salesInvoiceImg}
          alt="Sales Invoice Extension Setup"
          onClose={() => setPopup(null)}
        />
      )}
      {popup === "credit" && (
        <ImagePopup
          src={creditNoteImg}
          alt="Credit Note Extension Setup"
          onClose={() => setPopup(null)}
        />
      )}

      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-white mb-4">Welcome to FIRS GO!</h1>
          <h3 className="text-2xl text-gray-300">Streamline Your E-Invoicing Process with Ease</h3>
        </div>

        {/* Main Content */}
        <div className="bg-white/10 backdrop-blur-md rounded-2xl shadow-2xl p-8 md:p-12">
          <p className="text-xl text-gray-200 leading-relaxed mb-8">
            FIRS GO! is a user-friendly web service designed to seamlessly connect the "Manager Cloud Accounting" app with FIRS
            E-Invoicing system. With FIRS GO!, you can generate and send electronic invoices more easily than ever before.
          </p>

          {/* What is FIRS Section */}
          <h4 className="text-3xl font-semibold text-white mt-10 mb-4">What is FIRS?</h4>
          <p className="text-gray-200 leading-relaxed mb-6">
            FIRS is Nigeria's pioneering national electronic invoicing system, introduced through a visionary partnership between the Nigeria Revenue Service (NRS) and the Merchant Buyer Solution (MBS). Designed to revolutionize the country's fiscal landscape, FIRS seeks to:
          </p>

          <ul className="space-y-3 mb-8">
            <li className="bg-white/5 rounded-lg p-4 text-gray-200 border border-gray-600 hover:bg-white/10 transition-colors">
              Elevate transparency in sales and purchase transactions.
            </li>
            <li className="bg-white/5 rounded-lg p-4 text-gray-200 border border-gray-600 hover:bg-white/10 transition-colors">
              Simplify tax data collection for the NRS with seamless efficiency.
            </li>
            <li className="bg-white/5 rounded-lg p-4 text-gray-200 border border-gray-600 hover:bg-white/10 transition-colors">
              Modernize Nigeria's tax infrastructure by embracing cutting-edge digital invoicing solutions.
            </li>
          </ul>

          {/* Free Service Card */}
          <div className="bg-gradient-to-r from-cyan-500/20 to-purple-500/20 border border-cyan-500/50 rounded-xl p-6 mb-8">
            <h5 className="text-2xl font-bold text-cyan-300 mb-3">Free for all Manager Accounting Users!</h5>
            <p className="text-gray-200 leading-relaxed">
              FIRS GO! is now available at no charge to all users of the "Manager" accounting application. Thanks to our joint efforts with the "Manager" team, we're able to deliver this service completely free of hidden costs or subscription requirements, empowering your business with the best tools possible.
            </p>
          </div>

          {/* How to Start Section */}
          <h4 className="text-3xl font-semibold text-white mt-10 mb-4">How to Start?</h4>
          <p className="text-gray-200 leading-relaxed mb-6">
            To get started, you need to set up two extensions inside your <span className="text-cyan-400 font-semibold">Manager</span> accounting application.
            Navigate to <span className="text-cyan-400 font-semibold">Settings &rsaquo; Extensions</span> and create the following two extensions exactly as shown:
          </p>

          {/* Extension Setup Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">

            {/* Extension 1 — Sales Invoice */}
            <div className="bg-white/5 border border-cyan-500/40 rounded-xl p-6 hover:bg-white/10 transition-colors">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-2xl">🧾</span>
                <h6 className="text-lg font-bold text-cyan-300">1. Sales Invoice Extension</h6>
              </div>
              <ul className="text-gray-300 text-sm space-y-1 mb-4">
                <li><span className="text-gray-400">Name:</span> <span className="font-semibold text-white">INVOICE_FIRS</span></li>
                <li><span className="text-gray-400">Source:</span> URL</li>
                <li><span className="text-gray-400">Endpoint:</span> <span className="font-mono text-cyan-400">https://firs.visioncorego.com</span></li>
                <li><span className="text-gray-400">Placement:</span> <span className="font-mono text-cyan-400">/sales-invoice-view</span></li>
              </ul>
              <button
                onClick={() => setPopup("sales")}
                className="w-full text-center px-4 py-2 bg-cyan-500/20 hover:bg-cyan-500/40 text-cyan-300 font-semibold rounded-lg border border-cyan-500/50 transition-colors cursor-pointer text-sm"
              >
                View Setup Screenshot →
              </button>
            </div>

            {/* Extension 2 — Credit Note */}
            <div className="bg-white/5 border border-purple-500/40 rounded-xl p-6 hover:bg-white/10 transition-colors">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-2xl">📋</span>
                <h6 className="text-lg font-bold text-purple-300">2. Credit Note Extension</h6>
              </div>
              <ul className="text-gray-300 text-sm space-y-1 mb-4">
                <li><span className="text-gray-400">Name:</span> <span className="font-semibold text-white">CREDITNOTE_FIRS</span></li>
                <li><span className="text-gray-400">Source:</span> URL</li>
                <li><span className="text-gray-400">Endpoint:</span> <span className="font-mono text-purple-400">https://firs.visioncorego.com</span></li>
                <li><span className="text-gray-400">Placement:</span> <span className="font-mono text-purple-400">/credit-note-view</span></li>
              </ul>
              <button
                onClick={() => setPopup("credit")}
                className="w-full text-center px-4 py-2 bg-purple-500/20 hover:bg-purple-500/40 text-purple-300 font-semibold rounded-lg border border-purple-500/50 transition-colors cursor-pointer text-sm"
              >
                View Setup Screenshot →
              </button>
            </div>
          </div>

          {/* After Setup Instructions */}
          <div className="bg-green-500/10 border border-green-500/40 rounded-xl p-6 mb-8">
            <h6 className="text-lg font-bold text-green-300 mb-2">✅ After Setting Up the Extensions</h6>
            <p className="text-gray-200 leading-relaxed">
              Once both extensions have been successfully created, navigate to any <span className="text-white font-semibold">Sales Invoice</span> or <span className="text-white font-semibold">Credit Note</span> within Manager. You will notice a new extension button displayed at the bottom of the document view. Clicking this button will launch the <span className="text-cyan-400 font-semibold">FIRS GO!</span> e-invoicing process directly within that document, allowing you to generate and submit your e-invoice with ease.
            </p>
          </div>

          {/* Video Demo Button */}
          <div className="text-center my-10">
            <a
              href="#"
              className="inline-block px-8 py-4 bg-gradient-to-r from-cyan-500 to-purple-500 hover:from-cyan-600 hover:to-purple-600 text-white font-bold text-lg rounded-lg shadow-lg transform hover:scale-105 transition-all duration-200"
            >
              Video Demonstration
            </a>
          </div>

          
          {/* Contact Information */}
          <div className="mt-10 text-center space-y-4 border-t border-gray-600 pt-8">
            <p className="text-lg text-gray-200">
              Consultant : <span className="text-cyan-400 font-bold">AI & Co Accountants</span>
              {' '}<span className="text-cyan-400 font-bold">+2348035674941</span>
            </p>
            <p className="text-lg text-gray-200">
              Technical Support: <span className="text-cyan-400 font-bold">WhatsApp: +94758384141</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppHome;
